import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';

import { BaseComponentCanDeactivate } from 'app/@auth/guards/changes.guard';
import {
  DEFAULT_DURATION,
  MealPlan,
  MealPlanData,
  TemplatePlan,
} from 'app/@core/interfaces/common/CalorieFriend/plan';
import { Utility } from 'app/@core/utils/utility';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-template-create',
  templateUrl: './template-create.component.html',
  styleUrls: ['./template-create.component.scss'],
})
export class MealPlanTemplateCreateComponent
  extends BaseComponentCanDeactivate
  implements OnInit
{
  planGenerateForm: FormGroup;
  templatePlan: MealPlan = null;
  isPublic: boolean = false;
  isLoading: boolean = false;

  get templateName(): AbstractControl {
    return this.planGenerateForm.get('templateName');
  }
  get templateDescription(): AbstractControl {
    return this.planGenerateForm.get('templateDescription');
  }

  constructor(
    private fb: FormBuilder,
    private mealPlanService: MealPlanData,
    protected ref: NbDialogRef<MealPlanTemplateCreateComponent>,
    private toasterService: NbToastrService,
    private router: Router,
    dialogService: NbDialogService
  ) {
    super(dialogService);
  }

  ngOnInit(): void {
    if (!this.templatePlan)
      this.templatePlan = {
        id: -1,
        days: null,
        name: 'New Plan',
        description: '',
        notes: '',
        patientID: null,
        createdDate: null,
        active: false,
        zOrder: Utility.INT32_MAX,
        duration: DEFAULT_DURATION,
      };

    this.initForm();
  }

  initForm(): void {
    this.planGenerateForm = this.fb.group({
      templateName: this.fb.control(`Untitled Meal Plan (${moment().format('MMM DD, YYYY')})`, [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(50),
      ]),
      templateDescription: this.fb.control('', [Validators.maxLength(500)]),
    });
    super.initForm(this.planGenerateForm);
  }

  onCreateTemplate(): void {
    if (!this.templatePlan) return;

    const template: TemplatePlan<MealPlan> = {
      name: this.templateName.value,
      description: this.templateDescription.value,
      thePlan: this.templatePlan,
      isPublic: this.isPublic,
    };

    super.resetDirty();
    this.isLoading = true;
    this.mealPlanService.CreateTemplate(template)
    .pipe(finalize(() => this.isLoading = false))
    .subscribe(
      (res: TemplatePlan<MealPlan>) => {
        this.router.navigate([
          '/pages/CalorieFriend/Template/', res.id
        ]);
        this.toasterService.success('', `Item template has been created!`);
        this.ref.close();
      },
      () =>
        this.toasterService.danger('', 'Problem with creating the template.')
    );
  }

  onCancel(): void {
    super.back(() => this.ref.close());
  }

  onTemplateNameChange(): void {
    if (this.templateName.value === '')
      this.templateName.setValue('Untitled Meal Plan');
  }

  get valid(): boolean {
    return this.planGenerateForm.valid && !!this.templatePlan;
  }
}
